import React from 'react'
import * as S from '../../styles'

export const SecondRowWidgets = ({
  devicesAccessState,
  renderStatusWidget,
  renderDeviceStatusWidget
}) => {
  const renderSecondRow = () => {
    if (devicesAccessState) {
      return (
        <S.Grid
          leftChildFrWidth={6}
          rightChildFrWidth={6}
        >
          {renderStatusWidget}
          {renderDeviceStatusWidget}
        </S.Grid>
      )
    }
    return null
  }

  return <>{renderSecondRow()}</>
}

export default SecondRowWidgets
